export default __webpack_public_path__ + "static/media/stepTwoGirl.868d1474.png";